import { call, takeEvery, takeLatest, delay, all, put, select } from 'redux-saga/effects'
import { getIsSegmapFetched } from './selectors'
import { savedSegmap, fetchedSegmap, storeSearchSegmapResult, deletedSegmap, savedCompanyDetails } from './actions'
import axios from 'axios';
import { handlError, parseError } from '../../app/serverError'
import { URL, getHeaderJWT } from '../../../store/path'
import userACL from '../../../store/access'
import { merge } from 'lodash'

// const delay = (ms) => new Promise(res => setTimeout(res, ms))

//#region Saga for Create Segmap 

function* createSegmap() {
  yield takeEvery('CREATE_SEGMAP', saveSegmap)
}

function* saveSegmap(action) {
  const { response, error } = yield call(saveSegmapAPI, action.payload)
  if (response) {
    const data = response.data || {}
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Save failed.'
      yield put(savedSegmap(action.payload, 'error', msg))
    } else {
      yield put(savedSegmap(action.payload, 'success', data.msg || data.data || 'Saved successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

function saveSegmapAPI(data) {
  return axios.post(URL + '/master/segmap/add', data, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#endregion


//#region Saga for Edited Segmap 

function* editSegmap() {
  yield takeEvery('EDIT_SEGMAP', saveEditedSegmap)
}

function* saveEditedSegmap(action) {
  const { response, error } = yield call(editSegmapAPI, action.payload)
  if (response) {
    const data = response.data || {}
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Update failed.'
      yield put(savedSegmap(action.payload, 'error', msg))
    } else {
      yield put(savedSegmap(action.payload, 'success', data.msg || data.data || 'Updated successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

function editSegmapAPI(data) {
  let userid = data.id
  return axios.post(URL + '/master/segmap/update/' + userid, data, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#endregion


//#region Saga for Delete Segmap 

function* deleteSegmap() {
  yield takeEvery('DELETE_SEGMAP', saveDeleteSegmap)
}

function* saveDeleteSegmap(action) {
  const { response, error } = yield call(deleteSegmapAPI, action.payload)
  if (response) yield put(deletedSegmap({ id: action.payload.id, msg: response.data }))
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

function deleteSegmapAPI(data) {
  let segmapId = data.id
  return axios.post(URL + '/master/segmap/delete/' + segmapId, data, getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#endregion


//#region Saga for List Segmap 

function* fetchSegmap() {
  yield takeEvery('FETCH_SEGMAP', requestSegmap)
}


function* requestSegmap() {
  const isSegmapFetched = yield select(getIsSegmapFetched);
  const { data } = yield call(requestSegmapAPI)
  if (data) yield put(fetchedSegmap(data))
}


function requestSegmapAPI(data) {
  data = merge({}, data, userACL.atFetch())
  return axios.post(URL + '/master/segmap/list', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


//#region Saga for Search Segmap 

function* searchSegmap() {

  yield takeLatest('SEARCH_SEGMAP', initiateSearch)

}

function* initiateSearch(action) {
  yield delay(350)
  let { data } = yield call(searchAPI, action.payload)
  yield put(storeSearchSegmapResult(data))

}

function searchAPI(data) {
  return axios.post(URL + '/segmap/search/' + data, data, getHeaderJWT(), { crossDomain: true })
}

//#endregion

//#region Saga for Create Segmap 

function* fetchCompanyDetails() {
  yield takeEvery('GET_COMPANY_DETAILS', saveCompanyDetails)
}

function* saveCompanyDetails(action) {
  const { response, error } = yield call(saveCompanyDetailsAPI, action.payload)
  if (response) {
    if (response.data) {
      yield put(savedCompanyDetails(response.data))
    } else {
      yield put(savedCompanyDetails({}))
    }

  }
  else {
    yield put(savedCompanyDetails({}))
    // yield put(handlError(action, parseError(error)))
    // sagaErrorMessage(error, action)
  }
}

function saveCompanyDetailsAPI(data) {
  return axios.post(URL + '/upload/get-param', getHeaderJWT(), { crossDomain: true })
    .then(response => ({ response }))
    .catch(error => ({ error }))
}

//#endregion


const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* segmapSaga() {
  yield all([
    createSegmap(),
    fetchSegmap(),
    editSegmap(),
    deleteSegmap(),
    searchSegmap(),
    // fetchCompanyDetails(),
  ])
}  